/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: patched for B4A-7073 (IsKit / ProductKit).
 */

import { ProductKitComponent } from './productKitComponent';

export interface ProductVariant {
  allocationCost?: number;
  brandId?: number;
  brandName?: string;
  brinde?: boolean;
  cean?: string;
  cfop?: string;
  costPrice?: number;
  cst?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  defaultImageURL?: string;
  diamanteVermelho?: ProductVariant.DiamanteVermelhoEnum;
  displayOrder?: number;
  expiration?: string;
  externalId?: number;
  externalStoreUrl?: string;
  extipi?: string;
  genero?: string;
  inStock?: number;
  inStockAcquisition?: number;
  inStockFidelization?: number;
  inStockInfluencerB4A?: number;
  inStockReserveMarketing?: number;
  internalEAN?: string;
  invoiceName?: string;
  invoicePrice?: number;
  isSellable?: boolean;
  isSellableUrl?: boolean;
  isTradeable?: boolean;
  isKit?: boolean;
  kitComponents?: Array<ProductKitComponent>;
  longExternalStoreUrl?: string;
  maxTradesPerPerson?: number;
  millenniumSKU?: string;
  ncm?: string;
  orderCount?: number;
  productId?: number;
  productVariantId?: number;
  productVariantName?: string;
  qtdItens?: number;
  salePrice?: number;
  saleStock?: number;
  syncedOnBling?: Date;
  tipoEstoque?: ProductVariant.TipoEstoqueEnum;
  tradeActive?: boolean;
  tradeCount?: number;
  tradePoints?: number;
  tradeStock?: number;
  unitMeasure?: number;
  unitName?: string;
  variantSummary?: string;
  weight?: number;
  wmsId?: number;
}
export namespace ProductVariant {
  export type DiamanteVermelhoEnum =
    | 'red diamond'
    | 'red diamond bag'
    | 'red diamond box'
    | 'red diamond combo';
  export const DiamanteVermelhoEnum = {
    Diamond: 'red diamond' as DiamanteVermelhoEnum,
    DiamondBag: 'red diamond bag' as DiamanteVermelhoEnum,
    DiamondBox: 'red diamond box' as DiamanteVermelhoEnum,
    DiamondCombo: 'red diamond combo' as DiamanteVermelhoEnum
  };
  export type TipoEstoqueEnum = 'classico' | 'premium';
  export const TipoEstoqueEnum = {
    Classico: 'classico' as TipoEstoqueEnum,
    Premium: 'premium' as TipoEstoqueEnum
  };
}
